import { useState, useEffect } from 'react';
import { Pagination, Form, Spinner, Modal, OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { toast } from 'sonner';
import { FaFilter, FaTrash, FaEdit , FaShoppingCart } from 'react-icons/fa';
import { deleteRfi, getAllRfi, getRfiByDate, getRfiByMonth, getRfiByStatus, getRfiByYear,updateRfi } from '../../service/api/RfiService';
import useSelectedDomain from '../../service/Hooks/useSelectedDomain';
import MesRfiModal from './MesRfiModal';
import { useUserData } from '../../service/api/useUserData';
// import FormulaireRfi from './FormulaireRfi';

export default function ListeRfi() {
    const selectedDomain = useSelectedDomain();
    const [rfis, setRfis] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [statusFilter, setStatusFilter] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [showEditRfiModal, setShowEditRfiModal] = useState(false);
    const [editRfiData, setEditRfiData] = useState({
        id: null,
        securityName: '',
        price: '',
        quantity: '',
        minQuantity: '',
        side: '',
        status: '',
    });

    // pour le creatorId
    const [showMesRfiModal, setShowMesRfiModal] = useState(false);
    const [creatorId, setCreatorId] = useState(null);

    // actualiser en silence
    const silentRefreshRfis = async () => {
        if (!selectedDomain || !selectedDomain.id) return;
        try {
            let data;
            if (statusFilter) {
                data = await getRfiByStatus(statusFilter, selectedDomain.id, currentPage, pageSize);
            } else {
                data = await getAllRfi(currentPage, pageSize);
            }
    
            if (data && data.items) {
                setRfis(data.items);
            }
        } catch (error) {
            toast.error('Erreur lors de l\'actualisation des RFIs.');
        }
    };
    
    // actualiser
    useEffect(() => {
        fetchRfis(); // Chargement initial avec affichage du spinner
        const intervalId = setInterval(silentRefreshRfis, 10000); // Actualisation silencieuse
        return () => clearInterval(intervalId);
    }, [currentPage, pageSize, selectedDomain, statusFilter]);
    
    // recuperer l'id de accountId
    const { getUserInfo } = useUserData();
    useEffect(() => {
        async function fetchUserData() {
            const userInfo = await getUserInfo();
            if (!userInfo) return;
            const { accountId } = userInfo;
            setCreatorId(accountId);
        }
        fetchUserData();
    }, []);

    const handleShowMesRfiModal = () => {
        setShowMesRfiModal(true);
    };

    const handleCloseMesRfiModal = () => {
        setShowMesRfiModal(false);
    };

    // pour delete
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [rfiToDelete, setRfiToDelete] = useState(null);

    const handleShowDeleteModal = (rfiId) => {
        setRfiToDelete(rfiId);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setRfiToDelete(null);
    };

    const handleDeleteRfi = async () => {
        try {
            await deleteRfi(rfiToDelete);
            toast.success('RFI supprimée avec succès.');
            fetchRfis();
        } catch (error) {
            toast.error('Erreur lors de la suppression de la RFI.');
        } finally {
            handleCloseDeleteModal();
        }
    };
    const handleShowEditRfiModal = (rfi) => {
        setEditRfiData({
          id: rfi.id,
          securityName: rfi.securityName || '',
          price: rfi.price || '',
          quantity: rfi.quantity || '',
          minQuantity: rfi.minQuantity || '',
          side: rfi.side || '',
          status: rfi.status || '',
        });
        setShowEditRfiModal(true);
    };
    const handleCloseEditRfiModal = () => {
        setShowEditRfiModal(false);
        setEditRfiData({
          id: null,
          securityName: '',
          price: '',
          quantity: '',
          minQuantity: '',
          side: '',
          status: '',
        });
    };
    const validateEditRfiData = (data) => {
        // console.log('Validation des données :', data);
      
        if (!data.securityName || !data.price || !data.quantity) {
          // console.log('Validation échouée : champs obligatoires manquants.');
          toast.error('Veuillez remplir tous les champs obligatoires.');
          return false;
        }
        if (isNaN(data.price) || data.price <= 0) {
          // console.log('Validation échouée : prix invalide.');
          toast.error('Le prix doit être un nombre positif.');
          return false;
        }
        if (isNaN(data.quantity) || data.quantity <= 0) {
          // console.log('Validation échouée : quantité invalide.');
          toast.error('La quantité doit être un nombre positif.');
          return false;
        }
      
        // console.log('Validation réussie.');
        return true;
      };
      const handleUpdateRfi = async () => {
        // console.log('Données avant validation :', editRfiData);
        // Validation
        if (!validateEditRfiData(editRfiData)) {
          // console.log('Validation échouée.');
          return;
        }
      
        try {
          // Préparer le payload
          const dataToSend = { ...editRfiData };
          // console.log("Données envoyées à l'API :", dataToSend);
          // Appel au service : id en premier, payload en second
          const result = await updateRfi(editRfiData.id, dataToSend);
          // console.log("Réponse de l'API :", result);
      
          toast.success('RFI mise à jour avec succès.');
          handleCloseEditRfiModal();
          fetchRfis();
        } catch (error) {
          // console.error('Erreur lors de la mise à jour de la RFI :', error);
          toast.error('Une erreur s\'est produite . Impossible de mettre à jour la RFI.');
        }
      };

    const fetchRfis = async () => {
        if (!selectedDomain || !selectedDomain.id) {
            return;
        }
        setIsLoading(true);
        try {
            let data;
            if (statusFilter) {
                data = await getRfiByStatus(statusFilter, selectedDomain.id);
            } else {
                data = await getAllRfi(currentPage, pageSize, selectedDomain.id, statusFilter);
            }

            if (Array.isArray(data)) {
                setRfis(data);
                setTotalPages(Math.ceil(data.length / pageSize));
            } else {
                toast.info(data);
                setRfis([]);
                setTotalPages(0);
            }
        } catch (error) {
            toast.error('Erreur lors de la récupération des Rfis.');
            setRfis([]);
            setTotalPages(0);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchRfis();
    }, [currentPage, pageSize, selectedDomain, statusFilter]);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleStatusFilterChange = (e) => {
        setStatusFilter(e.target.value);
        setCurrentPage(1);
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'Pending':
                return 'warning';
            case 'Completed':
                return 'success';
            case 'Canceled':
                return 'danger';
            default:
                return 'secondary';
        }
    };

    function formatDate(dateString) {
        const date = new Date(dateString);
        const options = { day: 'numeric', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('fr-FR', options);
    }

    // gestions des filtres 
    const handleDateFilter = async () => {
        if (selectedDomain && selectedDomain.id) {
            setIsLoading(true);
            try {
                const results = await getRfiByDate(selectedDomain.id);
                setRfis(results);
                setTotalPages(1); // Mettre à jour totalPages si nécessaire
            } catch (error) {
                toast.error('Erreur lors de la récupération des RFIs par date.');
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleMonthFilter = async () => {
        if (selectedDomain && selectedDomain.id) {
            setIsLoading(true);
            try {
                const results = await getRfiByMonth(selectedDomain.id);
                setRfis(results);
                setTotalPages(1);
            } catch (error) {
                toast.error('Erreur lors de la récupération des RFIs par mois.');
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleYearFilter = async () => {
        if (selectedDomain && selectedDomain.id) {
            setIsLoading(true);
            try {
                const results = await getRfiByYear(selectedDomain.id);
                setRfis(results);
                setTotalPages(1);
            } catch (error) {
                toast.error('Erreur lors de la récupération des RFIs par année.');
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleResetFilters = () => {
        fetchRfis(); // Recharge la liste complète
    };

  return (
    <div>
        <div className="row">
                <Form.Group className="mb-3 d-flex align-items-center">
                    <Form.Label className=" text-start" style={{paddingLeft:"10px",marginBottom:"0px", width:"130px"}}>
                      <FaFilter/>Filtrer par statut :
                  </Form.Label>
                    <Form.Control as="select" onChange={handleStatusFilterChange} className='ms-2' style={{flex:"1"}}>
                        <option value="">Tous</option>
                        <option value="Pending">Pending</option>
                        <option value="Completed">Completed</option>
                        <option value="Canceled">Canceled</option>
                    </Form.Control>
                </Form.Group>
              
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-header">
                    <h4
          className="fw-bold text-primary fs-4 text-uppercase m-0"
          style={{
            letterSpacing: "1px",
            textShadow: "1px 1px 2px rgba(0, 0, 0, 0.2)"
          }}
              >Rfi</h4>                        
                        <div className="d-flex mb-3">
                          <Button variant="primary" onClick={handleShowMesRfiModal} className="me-2">
                            Mes RFIs Cree
                          </Button>
                          <Button variant="outline-primary" onClick={handleDateFilter} className="me-2">Filtrer par Date</Button>
                          <Button variant="outline-danger" onClick={handleResetFilters}>Réinitialiser</Button>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                        {isLoading ? (
                            <div className="d-flex justify-content-center">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Chargement...</span>
                            </Spinner>
                            </div>
                        ) : rfis.length > 0 ? (
                        <table className="table table-responsive-md table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Titre</th>
                                    <th>Detenant</th>
                                    <th>Type Ordre</th>
                                    <th style={{paddingLeft:"40px"}}>Prix</th>
                                    <th>Quantité</th>
                                    <th>Quantité minimum</th>
                                    <th>Status</th>
                                    {/* <th>Creation Date</th> */}
                                    <th> Dernier Date </th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rfis.map((rfi) => (
                                <tr key={rfi.id}>
                                    <td className="fw-semibold">{rfi.securityName}</td>
                                    <td className="text-dark">{rfi.fromAccountName}</td>
                                    <td className="text-center">
                                        <span className={`badge rounded bg-${rfi.side === 'Buy' ? 'success' : 'danger'}`}>
                                            {rfi.side}
                                        </span>
                                    </td>
                                    <td className="py-2"> 
                                  <span className="badge bg-light text-dark px-2">
                                    {new Intl.NumberFormat("fr-FR", {
                                      style: "decimal",
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 0,
                                      useGrouping: true
                                    }).format( rfi.price||0)} Fcfa
                                  </span>
                                </td>
                                    <td className="text-center fw-medium">{rfi.quantity}</td>
                                    <td className="text-center text-muted">{rfi.minQuantity}</td>
                                    <td>
                                        <span className={`badge rounded bg-${getStatusColor(rfi.status)}`}>
                                            {rfi.status}
                                        </span>
                                    </td>
                                    {/* <td class="text-nowrap text-center">{formatDate(rfi.creationDate)}</td> */}
                                    <td className="text-nowrap text-center">{rfi.lastUpdateDate ? formatDate(rfi.lastUpdateDate) : 'N/A'}</td>
                                    <td>
                                      <div>
                                      <OverlayTrigger placement="top" overlay={<Tooltip>Modifier</Tooltip>}>
                                        <button
                                            className="btn btn-primary shadow btn-xs sharp me-1"
                                            onClick={() => handleShowEditRfiModal(rfi)}
                                        >
                                            <FaEdit />
                                        </button>
                                        </OverlayTrigger>
                                        <OverlayTrigger placement="top" overlay={<Tooltip>Supprimer</Tooltip>}>
                                          <button onClick={() => handleShowDeleteModal(rfi.id)} className="btn btn-danger shadow btn-xs sharp">
                                            <FaTrash />
                                          </button>
                                        </OverlayTrigger>
                                        {rfi.status === 'Completed' && (
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Créer un ordre</Tooltip>}>
                                                <button className="btn btn-success shadow btn-xs sharp ms-1">
                                                    <FaShoppingCart />
                                                </button>
                                            </OverlayTrigger>
                                        )}
                                      </div>
                                    </td>
                                </tr>
                                ) )}
                            </tbody>
                            </table>
                        ) : (
                          <div className="text-center text-muted">Aucune RFI trouvée.</div>
                        )}
                        </div>

                        <Pagination className="justify-content-center">
                            <Pagination.Prev
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            />
                            {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => (
                            <Pagination.Item
                                key={pageNumber}
                                active={pageNumber === currentPage}
                                onClick={() => handlePageChange(pageNumber)}
                            >
                                {pageNumber}
                            </Pagination.Item>
                            ))}
                            <Pagination.Next
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            />
                        </Pagination>
                    </div>
                </div>
            </div>
        </div>

        <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
            <Modal.Header closeButton>
               <Modal.Title>Confirmer la suppression</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Êtes-vous sûr de vouloir supprimer cette RFI ? Cette action est irréversible.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseDeleteModal}>
                    Annuler
                </Button>
                <Button variant="danger" onClick={handleDeleteRfi}>
                    Supprimer
                </Button>
            </Modal.Footer>
        </Modal>
       
        <Modal show={showEditRfiModal} onHide={handleCloseEditRfiModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Modifier la RFI</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="mb-3">
                <label htmlFor="securityName" className="form-label">Nom de la sécurité</label>
                <input
                  type="text"
                  className="form-control"
                  id="securityName"
                  value={editRfiData.securityName}
                  onChange={(e) => setEditRfiData({ ...editRfiData, securityName: e.target.value })}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="price" className="form-label">Prix</label>
                <input
                  type="number"
                  className="form-control"
                  id="price"
                  value={editRfiData.price}
                  onChange={(e) => setEditRfiData({ ...editRfiData, price: parseFloat(e.target.value) || '' })} 
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="quantity" className="form-label">Quantité</label>
                <input
                  type="number"
                  className="form-control"
                  id="quantity"
                  value={editRfiData.quantity}
                  onChange={(e) => setEditRfiData({ ...editRfiData, quantity: e.target.value })}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="minQuantity" className="form-label">Quantité minimale</label>
                <input
                  type="number"
                  className="form-control"
                  id="minQuantity"
                  value={editRfiData.minQuantity}
                  onChange={(e) => setEditRfiData({ ...editRfiData, minQuantity: e.target.value })}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="side" className="form-label">Côté</label>
                <select
                  className="form-control"
                  id="side"
                  value={editRfiData.side}
                  onChange={(e) => setEditRfiData({ ...editRfiData, side: e.target.value })}
                >
                  <option value="Buy">Acheter</option>
                  <option value="Sell">Vendre</option>
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="status" className="form-label">Statut</label>
                <select
                  className="form-control"
                  id="status"
                  value={editRfiData.status}
                  onChange={(e) => setEditRfiData({ ...editRfiData, status: e.target.value })}
                >
                  <option value="Pending">En attente</option>
                  <option value="Completed">Terminé</option>
                  <option value="Canceled">Annulé</option>
                </select>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseEditRfiModal}>
              Annuler
            </Button>
            <Button variant="primary" onClick={handleUpdateRfi}>
              Mettre à jour
            </Button>
          </Modal.Footer>
        </Modal>
        {/* modal pour la liste par creatorId */}
        <MesRfiModal show={showMesRfiModal} onClose={handleCloseMesRfiModal} creatorId={creatorId} />
    </div>
  )
}
